import { fetchArticle } from '@/redux/modules/article/article.actions';
import { DataLoaderParams } from '@/types/DataLoaderParams';

/**
 * Loads article data for `/guides/:topic/:slug`.
 */
export const articlePageData = async ({ match: { params }, store: { dispatch } }: DataLoaderParams) => {
    const { slug, topic } = params;

    if (!topic || !slug) {
        return;
    }

    await dispatch(fetchArticle({ slug, topic }));
};
